import { Component, Input } from "@angular/core";
import { Platform } from "@ionic/angular";
import { ParagraphInterface } from "src/app/types/post";

@Component({
  selector: "app-paragraph",
  templateUrl: "./paragraph.component.html",
  styleUrls: ["./paragraph.component.scss"],
})
export class ParagraphComponent {
  desktop: boolean = false;
  maxHeight: string = "unset";
  maxHeightOpen: string = "30rem";
  maxHeightClosed: string = "4.6rem";
  readMoreVisible: boolean = false;

  @Input() node: ParagraphInterface;
  @Input() readMore: boolean = false;

  constructor(private platform: Platform) {
    this.platform.ready().then(() => {
      this.desktop = this.platform.is("desktop") || (typeof window !== "undefined" && window.innerWidth > 1200);

      if (this.readMore && !this.desktop) {
        this.maxHeight = this.maxHeightClosed;
      }
    });
  }

  toggleReadMore() {
    if (this.readMoreVisible) {
      this.maxHeight = this.maxHeightClosed;
    } else {
      this.maxHeight = this.maxHeightOpen;
    }

    this.readMoreVisible = !this.readMoreVisible;
  }
}
